/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/require-await */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-use-before-define */
import {Button, Form, InputGroup} from 'react-bootstrap';
import {useNavigate, useLocation} from 'react-router-dom';
import {toast} from 'react-toastify';
import type {SubmitHandler} from 'react-hook-form';
import {useController, useForm} from 'react-hook-form';
import {useState, useEffect} from 'react';

import LayoutMain from 'components/Layouts/LayoutMain';
import type {CreateUser, ResetPassword} from 'interfaces';
import {
	useCreateUserMutation,
	useUpdateUserMutation,
	useResetPasswordMutation,
} from 'services';

const stylePadding = {paddingLeft: '0.5rem'};

const PERMISSIONS = [
	'admin',
	'subscriber_provision',
	'subscriber_read_only',
	'plan_provision',
	'plan_read_only',
	'system_admin',
	'system_admin_read_only',
	'policy_engine',
	'policy_engine_read_only',
	'monitoring',
	'monitoring_read_only',
];

const UserDetail = () => {
	const navigate = useNavigate();
	const location = useLocation();

	const {state} = location;

	const [isEdit, setIsEdit] = useState(false);

	useEffect(() => {
		setIsEdit(state?.username?.length > 0);
	}, [state?.username]);

	const {
		register,
		handleSubmit,
		formState: {errors, isValid},
		watch,
		control,
		setValue,
	} = useForm<CreateUser>({
		mode: 'all',
		defaultValues: defaultData(state) as never,
	});

	const {
		register: registerPassword,
		handleSubmit: handleSubmitPassword,
		formState: {errors: errorsPassword, isValid: isValidPassword},
		watch: watchPassword,
	} = useForm<ResetPassword>({
		mode: 'all',
		defaultValues: defaultData(state) as never,
	});

	const permissions = watch('permissions');

	const [createUser, {isLoading}] = useCreateUserMutation();
	const [updateUser, {isLoading: isLoadingUpdate}] = useUpdateUserMutation();
	const [resetPassword, {isLoading: isLoadingReset}] =
		useResetPasswordMutation();

	/**
	 * The above function is a TypeScript React function that handles form submission and performs some
	 * data manipulation and API calls.
	 */
	const onSubmitUser: SubmitHandler<CreateUser> = async formData => {
		try {
			if (isEdit) {
				// eslint-disable-next-line no-console
				await updateUser(formData).unwrap();
			} else {
				// eslint-disable-next-line no-console
				await createUser(formData).unwrap();
				setIsEdit(true);
			}

			toast.success(`${isEdit ? 'Update' : 'Create'} Successfully!`);
		} catch (error) {
			console.error(error);
		}
	};

	const onSubmitReset: SubmitHandler<ResetPassword> = async formData => {
		try {
			// eslint-disable-next-line no-console
			await resetPassword(formData).unwrap();

			toast.success('Password reset successfully!');
		} catch (error) {
			console.error(error);
		}
	};

	return (
		<LayoutMain isLoading={isLoading || isLoadingUpdate || isLoadingReset}>
			<div className="container-fluid">
				{/* Intro */}
				<div className="row">
					<div className="col-md-12">
						<h1 className="mt-2">Users Management</h1>
					</div>
				</div>

				<nav aria-label="breadcrumb">
					<ol className="breadcrumb">
						<li className="breadcrumb-item">
							<span
								role="button"
								tabIndex={0}
								className="text-primary"
								onClick={() => navigate(-1)}>
								Users Management
							</span>
						</li>
						<li className="breadcrumb-item active" aria-current="page">
							{isEdit ? 'Edit' : 'Create'}
						</li>
					</ol>
				</nav>

				{/* Users Management*/}
				<div className="row mt-4">
					<div className="col-md-12">
						<div className="card-tasks card">
							<div className="card-header">
								<i className="bi bi-person-lines-fill mr-3 float-left text-primary bi-2-5" />
								<h2 className="card-title">
									{isEdit ? 'Edit User' : 'New User'}
								</h2>
								<p className="card-category">
									{isEdit ? 'Edit the existent user' : 'Create a new user'}
								</p>
							</div>
							<div className="card-body">
								<div className="mt-1">
									<div className="row mb-5 d-flex justify-content-center">
										<div className="col-md-6 col-xl-4 mb-3">
											<Form
												className="rounded-3 text-bg-light p-2 needs-validation"
												onSubmit={handleSubmit(onSubmitUser)}>
												<h2>User detail</h2>
												<InputGroup className="mb-3">
													<InputGroup.Text style={stylePadding}>
														Username
													</InputGroup.Text>
													<Form.Control
														id="username"
														aria-label="username"
														placeholder=""
														{...register('username', {
															required: 'The field is required',
														})}
														className={errors.username ? 'is-invalid' : ''}
													/>
													{errors.username && (
														<small className="invalid-feedback d-block">
															{errors.username.message}
														</small>
													)}
												</InputGroup>

												<InputGroup className="mb-3">
													<InputGroup.Text style={stylePadding}>
														E-mail
													</InputGroup.Text>
													<Form.Control
														type="email"
														id="email"
														aria-label="email"
														placeholder=""
														{...register('email', {
															required: 'The field is required',
															validate: {
																maxLength: v =>
																	v.length <= 50 ||
																	'The email should have at most 50 characters',
																matchPattern: v =>
																	/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
																		v,
																	) || 'Enter a valid e-mail address',
															},
														})}
														className={errors.email ? 'is-invalid' : ''}
													/>
													{errors.email && (
														<small className="invalid-feedback d-block">
															{errors.email.message}
														</small>
													)}
												</InputGroup>

												<InputGroup className="mb-3">
													<InputGroup.Text style={stylePadding}>
														Name
													</InputGroup.Text>
													<Form.Control
														id="name"
														aria-label="name"
														placeholder=""
														{...register('name', {
															required: 'The field is required',
														})}
														className={errors.name ? 'is-invalid' : ''}
													/>
													{errors.name && (
														<small className="invalid-feedback d-block">
															{errors.name.message}
														</small>
													)}
												</InputGroup>

												<InputGroup className="mb-3">
													<InputGroup.Text style={stylePadding}>
														Surname
													</InputGroup.Text>
													<Form.Control
														id="surname"
														aria-label="surname"
														placeholder=""
														{...register('surname', {
															required: 'The field is required',
														})}
														className={errors.surname ? 'is-invalid' : ''}
													/>
													{errors.surname && (
														<small className="invalid-feedback d-block">
															{errors.surname.message}
														</small>
													)}
												</InputGroup>

												{!isEdit && (
													<InputGroup>
														<InputGroup className="mb-3">
															<InputGroup.Text style={stylePadding}>
																Password
															</InputGroup.Text>
															<Form.Control
																type="password"
																id="password"
																aria-label="password"
																placeholder=""
																{...register('password', {
																	required: 'The field is required',
																})}
																className={errors.password ? 'is-invalid' : ''}
															/>
															{errors.password && (
																<small className="invalid-feedback d-block">
																	{errors.password.message}
																</small>
															)}
														</InputGroup>

														<InputGroup className="mb-3">
															<InputGroup.Text style={stylePadding}>
																Repeat Password
															</InputGroup.Text>
															<Form.Control
																type="password"
																id="repeat_password"
																aria-label="repeat_password"
																placeholder=""
																{...register('repeat_password', {
																	required: 'The field is required',
																	validate: (val: string | undefined) => {
																		if (watch('password') !== val) {
																			return 'Your passwords do no match';
																		}
																	},
																})}
																className={
																	errors.repeat_password ? 'is-invalid' : ''
																}
															/>
															{errors.repeat_password && (
																<small className="invalid-feedback d-block">
																	{errors.repeat_password.message}
																</small>
															)}
														</InputGroup>
													</InputGroup>
												)}

												<Form.Label className="font-weight-bold">
													Permissions
												</Form.Label>
												<div key="inline-check" className="mb-3 ml-3 my-2">
													<Checkboxes
														options={PERMISSIONS}
														control={control}
														name="permissions"
														setValue={setValue}
													/>
												</div>

												<div className="mb-3 ml-3 my-2">
													<Form.Check
														id="apiConsumer"
														aria-label="apiConsumer"
														label="apiConsumer"
														type="switch"
														{...register('apiConsumer', {
															required: false,
														})}
													/>
												</div>

												<Button
													disabled={!isValid || !permissions?.length}
													type="submit"
													className="mt-2"
													variant="primary"
													style={{color: 'white'}}>
													{isEdit ? 'Update' : 'Create'}
												</Button>
											</Form>
										</div>
										<div className="col-md-6 col-xl-3">
											{isEdit && (
												<Form
													className="rounded-3 text-bg-light p-2 needs-validation"
													onSubmit={handleSubmitPassword(onSubmitReset)}>
													<h2>Reset Password</h2>
													<InputGroup className="mb-3">
														<InputGroup.Text style={stylePadding}>
															Password
														</InputGroup.Text>
														<Form.Control
															type="password"
															id="reset_password"
															aria-label="password"
															placeholder=""
															{...registerPassword('password', {
																required: 'The field is required',
															})}
															className={
																errorsPassword.password ? 'is-invalid' : ''
															}
														/>
														{errorsPassword.password && (
															<small className="invalid-feedback d-block">
																{errorsPassword.password.message}
															</small>
														)}
													</InputGroup>

													<InputGroup className="mb-3">
														<InputGroup.Text style={stylePadding}>
															Repeat Password
														</InputGroup.Text>
														<Form.Control
															type="password"
															id="reset_repeat_password"
															aria-label="repeat_password"
															placeholder=""
															{...registerPassword('repeat_password', {
																required: 'The field is required',
																validate: (val: string | undefined) => {
																	if (watchPassword('password') !== val) {
																		return 'Your passwords do no match';
																	}
																},
															})}
															className={
																errorsPassword.repeat_password
																	? 'is-invalid'
																	: ''
															}
														/>
														{errorsPassword.repeat_password && (
															<small className="invalid-feedback d-block">
																{errorsPassword.repeat_password.message}
															</small>
														)}
													</InputGroup>
													<Button
														disabled={!isValidPassword}
														type="submit"
														className="mt-2"
														variant="primary"
														style={{color: 'white'}}>
														{'Reset'}
													</Button>
												</Form>
											)}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</LayoutMain>
	);
};

type TCheckboxes = {
	options: string[];
	control: any;
	name: string;
	setValue: any;
};
const Checkboxes = ({options, control, name, setValue}: TCheckboxes) => {
	const {field} = useController({
		control,
		name,
	});
	const [permissions, setPermissions] = useState(field.value || []);

	useEffect(() => {
		if (permissions.length > 0) {
			setValue(
				'permissions',
				permissions.filter((permission: string) => permission),
			);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [permissions]);

	/**
	 * The function `filterArrayPermissions` takes an array of strings and removes any elements that have a
	 * corresponding "opposite" element in the array.
	 * @param {string[]} array - An array of strings.
	 * @returns The function `filterArrayPermissions` returns an array of strings.
	 */
	const filterArrayPermissions = (array: string[]): string[] => {
		const rolesToCheck = [
			'subscriber_provision',
			'plan_provision',
			'system_admin',
			'policy_engine',
			'monitoring',
		];

		rolesToCheck.forEach(role => {
			let oppositeRole = `${role}_read_only`;

			if (role === 'subscriber_provision' || role === 'plan_provision') {
				const term = role?.split('_')[0];
				oppositeRole = `${term}_read_only`;
			}

			if (array.includes(role)) {
				const indexToRemove = array.indexOf(oppositeRole);
				if (indexToRemove !== -1) {
					array.splice(indexToRemove, 1);
				}
			} else if (array.includes(oppositeRole)) {
				const indexToRemove = array.indexOf(role);
				if (indexToRemove !== -1) {
					array.splice(indexToRemove, 1);
				}
			}
		});

		return array;
	};

	return (
		<>
			{options.map((option: string, index: number) => (
				<Form.Check
					key={option}
					name="permissions"
					type="switch"
					id={`custom-admin-${index}`}
					label={option}
					checked={permissions.includes(option)}
					value={option}
					onChange={e => {
						const valueCopy = [...permissions];
						valueCopy[index] = e.target.checked ? e.target.value : null;
						setPermissions(filterArrayPermissions(valueCopy));
					}}
				/>
			))}
		</>
	);
};

export const defaultData = (state?: CreateUser) => ({
	username: state?.username ?? '',
	email: state?.email ?? '',
	name: state?.name ?? '',
	surname: state?.surname ?? '',
	password: '',
	permissions: state?.permissions || [],
	apiConsumer: state?.apiConsumer ?? false,
});

export default UserDetail;
